import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphPersonsFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphPersonsFiltered: React.FC<ParagraphPersonsFilteredProps> = () => (
  <div className="Paragraph ParagraphPersonsFiltered">
    <View
      classes="row"
      id="persons_filtered"
      display="persons_filtered"
      storageType="url"
      withProvider
    />
  </div>
);

export default ParagraphPersonsFiltered;
